<template>
	<div class="page">
		<div class="find-help-header pad-x">
			<div class="contain">
				<Logo />
				<div class="onboarding-header-step">
					<div class="fs-14 lh-18 md-fs-16 md-lh-22 color-violet fw-700">{{ steps[currentStep - 1] }}</div>
					<div class="fs-14 lh-18 md-fs-16 md-lh-20 mt-4">
						Step {{ currentStep }} of {{ steps.length }}
					</div>
				</div>
				<div class="onboarding-header-actions">
					<router-link :to="{ name: $routes.Dashboard.name }" class="btn exit">Exit</router-link>
				</div>
			</div>
			<div v-if="progress != null" class="onboarding-header-progress">
				<div class="onboarding-header-progress-bar" :style="`width: ${(progress * 100).toFixed(2)}%`"></div>
			</div>
		</div>

		<div class="pad-x bg-gradient py-44">
			<router-view />
		</div>
	</div>
</template>

<script>
import layout from '@/mixins/layout';

export default {
	name: 'FindHelpLayout',
	mixins: [layout],
	data() {
		return {
			steps: [
				'Create Job',
				'View Search Results + Select Candidates',
				'Build Job Offer Queue',
			],
		};
	},
	computed: {
		currentStep() {
			switch (this.$route.name) {
				case 'findHelpDetails':
					return 1;
				case 'findHelpSearch':
					return 2;
				case 'findHelpQueueType':
					return 2;
				case 'findHelpQueue':
					return 3;
				default:
					return 1;
			}
		},
		progress() {
			return this.currentStep / this.steps.length;
		},
		rootClass() {
			return 'onboarding';
		},
	},
	destroyed() {
		const store = this.$store;
		store.commit('events/setSearchHiringUserProfile', null);
		store.commit('events/setSearchQueue', null);
	},
	watch: {
		$route: {
			handler(route) {
				if (route) {
					this.$store.commit('onboarding/setCurrentRouteName', route.name);
				}
			},
			immediate: true,
		},
	},
	metaInfo() {
		return {
			title: 'Find Help',
		};
	},
};
</script>
